<template>
  <span>
    %C₂H₆ = {{ formatNumberValue(data.percentageC2H6) }} |
    %CH₄ = {{ formatNumberValue(data.percentageCH4) }} |
    %H₂ = {{ formatNumberValue(data.percentageH2) }}
  </span>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatNumberValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
  },
};
</script>
